import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import LogoImage from "../images/logo/regular.svg";
import LogoText from "../images/logo/text.svg";

const logoVariants = {
    image: LogoImage,
    text: LogoText,
};

const Logo = ({ alt = "ShiftMed.com", className, variant = "image" }) => {
    const LogoVariant = logoVariants[variant];
    return <LogoVariant alt={alt} className={classNames("logo", className)} />;
};

Logo.propTypes = {
    alt: PropTypes.string,
    className: PropTypes.string,
    variant: PropTypes.string,
};

export default Logo;
